import { Injectable } from '@angular/core';
import {Socket} from "socket.io-client";
import {DefaultEventsMap} from "@socket.io/component-emitter";
import {Store} from "@ngrx/store";
import {Entity} from "../../state/entities/entity.model";
import {entityActions} from "../../state/entities/entity.actions";
import {selectIds} from "../../state/entities/entity.selector";
import {ServerEntity, serverEntityToEntity} from "../dtos/server-entity.dto";

@Injectable({
  providedIn: 'root'
})
export class EntitySeederService {

  knownEntityIds: string[] = []
  debug = false

  constructor(
      private store: Store,
  ) {
    this.store.select(selectIds).subscribe((ids) => {
      if (!ids) return
      this.knownEntityIds = ids as string[]
    })
  }

  log(message: string) {
    if (this.debug) {
      console.log(message)
    }
  }

  public async seedCoord(topic, entities: string[]) {
    for (const entityString of entities) {
      const entity = JSON.parse(entityString) as ServerEntity
      await this.seedEntity(entity);
    }
  }

  async seedEntity(entity: ServerEntity) {
    if (this.knownEntityIds.includes(entity.id)) {
      await this.updateEntity(entity)
      this.log(`[Entity Seeder] got existing entity ${entity.id}`)
    } else {
      this.log(`[Entity Seeder] got new entity ${entity.id}`)
      await this.createEntity(entity)
    }
  }


  async updateEntity(entity: ServerEntity) {
    this.store.dispatch(
        entityActions.netUpdated({
          entity: serverEntityToEntity(entity)
        })
    )
  }

  async createEntity(entity: any) {
    this.store.dispatch(
        entityActions.netCreated({
          entity: serverEntityToEntity(entity)
        })
    )
  }
}
